"use strict";
function e(t) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(t);
}
export {
  e as default
};
//# sourceMappingURL=index.es350.js.map
